import { z } from 'zod';

export const TimezoneOptionSchema = z.object({
  value: z.string(),
  label: z.string(),
  offset: z.string(),
  region: z.string(),
});

export const TimezoneGroupsSchema = z.record(z.string(), z.array(TimezoneOptionSchema));

export type TimezoneOption = z.infer<typeof TimezoneOptionSchema>;
export type TimezoneGroups = z.infer<typeof TimezoneGroupsSchema>;
